<div
  *ngIf="!this.authService.activeUser || !isCompanyMember"
  class="layout-middle-col"
  style="padding-bottom: 0; margin-bottom: -20px"
>
  <div *ngIf="!isCompanyMember" class="alert alert-info" style="line-height: 38px; margin-bottom: 0">
    <span i18n>You are not a member of this {{ lang('community') }}.</span>
    <a (click)="handleAction(joinAction, authService.selectedCompany)" class="btn btn-info float-right" i18n>Join</a>
    <div style="clear: both"></div>
  </div>
  <div
    *ngIf="!this.authService.activeUser && authService.getSubdomain()"
    class="alert alert-info"
    style="line-height: 38px"
  >
    <span i18n>Please sign in/register to participate.</span>
    <a
      [routerLink]="['/sign-up']"
      class="btn btn-info float-right"
      style="margin-left: 6px; text-decoration: none"
      i18n="@@createAccount"
      >Create Account</a
    >
    <a
      [routerLink]="['/sign-in']"
      class="btn btn-info float-right"
      style="margin-left: 6px; text-decoration: none"
      i18n="@@signIn"
      >Sign In</a
    >
    <div style="clear: both"></div>
  </div>
</div>

<div>
  <div class="layout-middle-col" *ngIf="authService.getSubdomain()">
    <div class="reception-heading">
      <h2 *ngIf="authService.companySettings?.isselfregister !== 0">
        <span i18n
          >Welcome to <em>{{ title }}</em></span
        >
        <span class="reception-action">
          <a
            *ngIf="isCompanyAdmin"
            class="btn btn-outline-primary"
            [routerLink]="['/combined/business/' + authService.selectedCompany?.id]"
          >
            <mdi name="Settings" size="20"></mdi> Admin
          </a>
          <a (click)="shareEvent()" class="btn btn-outline-primary"
            ><mdi name="Share" size="20"></mdi>&nbsp;<span i18n>Share Event</span></a
          >
        </span>
      </h2>
      <h2 *ngIf="!authService.companySettings?.isselfregister" i18n>Welcome</h2>
      <a
        *ngIf="!authService.companySettings?.isselfregister && isCompanyAdmin"
        class="btn btn-outline-primary reception-action"
        [routerLink]="['/combined/business/' + authService.selectedCompany?.id]"
      >
        <mdi name="Settings"></mdi> Admin
      </a>
    </div>

    <app-company-info></app-company-info>
  </div>

  <div class="layout-middle-col" *ngIf="!authService.getSubdomain()">
    <app-page-header [primaryAction]="addCommunityAction" (handlePrimaryAction)="addCommunity()" i18n
      >My Events</app-page-header
    >

    <app-no-records *ngIf="!authService.companies?.length"></app-no-records>

    <div class="cards" *ngIf="authService.companies?.length">
      <div *ngFor="let company of authService.companies">
        <app-card
          icon="Calendar"
          [maintitle]="company.name"
          [actions]="company.statusid === 1 ? [joinAction] : [enterAction]"
          (handleAction)="handleAction($event, company)"
        >
        </app-card>
      </div>
    </div>
  </div>
</div>
